import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import Basic from './Basic';
import Lowpass from './Lowpass';
import HighpassFilters from "./HighpassFilters";
import Bandpass from './Bandpass';
import Notchpass from "./Notchpass";
import Signals from "./Signals";
import SeriesProtocols from "./SeriesProtocols";
import CANBus from "./CANBus";
import PWM from "./PWM";

const ChangeComponents = {
    basic: Basic,
    lowpass: Lowpass,
    bandpass: Bandpass,
    notchpass: Notchpass,
    highpassfilters: HighpassFilters,
    signals: Signals,
    seriesprotocols: SeriesProtocols,
    canbus: CANBus,
    pwm: PWM,
  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }